export interface DeveloperContribution {
  firstName: string;
  lastName: string;
  commitCount: number;
}
